import { render, staticRenderFns } from "./produto.vue?vue&type=template&id=af1dc792&"
import script from "./produto.vue?vue&type=script&lang=js&"
export * from "./produto.vue?vue&type=script&lang=js&"
import style0 from "./produto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports